import { Component, OnInit, ViewEncapsulation, SecurityContext, Input, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';
import { ParticaService } from '../../services/partica.service';
import { AuthService } from '../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import * as md5 from 'md5';
import { environment } from '../../../environments/environment.staging';
import { APP_CONFIG } from '../../app.config';

declare var $: any;
declare var Stripe: any;
declare var $script: any;
declare var introJs: any;

@Component({
  selector: 'app-partica',
  templateUrl: './partica.component.html',
  styleUrls: ['./partica.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ParticaComponent implements OnInit, OnDestroy {
  authUser: any;
  particaAccountId: any;

  loading = false;
  isRegistered: boolean;

  user_token = '';

  article: any;
  articles = [];
  facets = [];
  streams = [];
  selectedStream: any;

  purchasedArticles = [];

  tmpIssueGuid = '';

  cartItems: any[];

  currentKeyword = 'real estate';
  currentFilter = [];

  availableFilters = [];

  creditCardForm: FormGroup;

  stripe: any;
  cardDetails: any;

  currentTab = 'search';
  currentPage = 1;
  maxPage = 1;

  totalArticles = 1;
  scrollEnable = true;

  purchasedCommand = 'read';
  outsideClick = false;

  chargebeeUrl = '';

  destroy$: Subject<boolean> = new Subject<boolean>();

  scriptsLoaded = false;

  subscribeForm: FormGroup;

  openBillingType = 'home';
  purchaseType = 'article';

  subscribedList = [];

  viewerUrl = '';

  constructor(
    @Inject(APP_CONFIG) private appConfig,
    private authService: AuthService,
    private particaService: ParticaService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.viewerUrl = this.appConfig.PARTICA_VIEWER_URL;
  }

  @Input() page: string;
  ngOnInit() {
    this.authUser = this.authService.auth;

    if ( this.authUser.user.partica_registered === 1 ) {
      this.isRegistered = true;
    }

    this.initPartica();

    this.particaService.onCheckAccount
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.isRegistered = true;

          this.user_token = response.data.token;
          this.particaAccountId = response.data.accountId;
          localStorage.setItem('PARTICA_TOKEN', btoa(this.user_token));
          localStorage.setItem('PARTICA_USER_ID', btoa(this.particaAccountId));
          localStorage.setItem('PARTICA_EXPIRY', btoa(new Date().toISOString().split('T')[0]));

          this.loading = false;
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetArticles
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.results !== 'undefined' ) {
          this.loading = false;
          if ( this.currentPage === 1 ) {
            this.articles = [];
            this.facets = [];
            this.articles = response.results.hits;
            this.currentPage += 1;
            this.totalArticles = response.results.total_hits;

            if ( this.totalArticles > 30 ) {
              this.scrollEnable = true;
            }
          } else {
            if ( typeof response.results !== 'undefined' ) {
              this.currentPage += 1;
              this.articles = [ ...this.articles, ...response.results.hits ];
            }
          }

          if ( typeof response.facetResults !== 'undefined' ) {
            this.facets = response.facetResults;
          }

          if ( typeof response.filters !== 'undefined' ) {
            this.availableFilters = Object.values(response.filters);
          }
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetArticle
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.articleId !== 'undefined' ) {
          this.article = response;

          if ( this.purchasedCommand === 'read' ) {
            this.outsideClick = true;
            $('.read-article').hide();
            $('.read-article').removeClass('hidden').toggle('slide', {
              direction: 'right'
            });
          }

          if ( this.purchasedCommand === 'insert' ) {
            $('#selectPictureModal').modal('show');
          }
          this.loading = false;
          this.changeDetector.detectChanges();
        }
        if ( typeof response.message !== 'undefined' ) {
          this.closeArticle();
          swal(
            'Partica API',
            response.message,
            'error'
          );
          this.loading = false;
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onPostCart
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' ) {
          if ( typeof response.status !== 'undefined' ) {
            swal({
              position: 'center',
              type: 'success',
              title: 'Article Added to Cart',
              showConfirmButton: false,
              timer: 1500
            });
          }
          if ( typeof response.message !== 'undefined' ) {
            swal(
              'Partica API',
              response.message,
              'error'
            );
          }

          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetCart
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'open' ) {
          this.loading = false;
          this.cartItems = response.shoppingCartItems;

          $('.shopping-cart').hide();
          $('.shopping-cart').removeClass('hidden').toggle('slide', {
            direction: 'right'
          });
          this.outsideClick = true;
          this.changeDetector.detectChanges();
        }
        if ( typeof response.message !== 'undefined' ) {
          this.loading = false;
          swal(
            'Partica API',
            response.message,
            'error'
          );
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onCheckPaymentSource
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.customerCardInfo === null ) {
          this.loading = false;
          $('.new-payment-form').hide();
          $('.new-payment-form').removeClass('hidden').toggle('slide', {
            direction: 'right'
          });
          this.outsideClick = true;

          this.openBilling('card');
          this.changeDetector.detectChanges();
        }
        if ( typeof response !== 'undefined' && typeof response.customerCardInfo !== 'undefined' ) {
          if ( this.purchaseType === 'subscription' ) {
            this.onSubscribe();
          }

          if ( this.purchaseType === 'article' ) {
            this.particaService.httpPostCheckout({
              CustomerAccountId: this.particaAccountId
            });
          }
        }
      }
    );

    this.particaService.onPostCheckout
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any ) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          swal(
            'Checkout Success',
            'You can view your purchase in the Purchased Articles section',
            'success'
          );

          this.outsideClick = true;
          this.mainContentClick();
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetPurchasedArticles
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        this.currentTab = 'purchased';
        if ( typeof response !== 'undefined' && typeof response === 'object' &&
            response.constructor === Object ) {
          this.loading = false;

          // tslint:disable-next-line:forin
          for ( const stream in response ) {
            this.purchasedArticles = this.purchasedArticles.concat(response[stream]);
          }

          this.purchasedArticles = this.particaService.sortByKey(this.purchasedArticles, 'added', true);

          // this.purchasedArticles = response.MyArticles;
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onParticaError
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.message !== 'undefined' ) {
          this.loading = false;
          swal(
            'Partica Error',
            response.message,
            (response.message === 'No Payment Method found. Please add a payment method to proceed' ? 'info' : 'error')
          );
          this.changeDetector.detectChanges();
        }
        if ( typeof response !== 'undefined' && typeof response.Message !== 'undefined' ) {
          this.loading = false;
          swal(
            'Partica Error',
            response.Message,
            'error'
          );
          this.changeDetector.detectChanges();
        }
        if ( response !== [] && typeof response.message === 'undefined' && response.message === null ) {
          this.loading = false;
          swal(
            'Partica Error',
            'Partica API is offline at the moment',
            'error'
          );
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onBuilderModalClose
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( response ) {
          this.articles = [];
          this.facets = [];
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetSsoToken
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.access_url !== 'undefined' ) {
          this.loading = false;
          this.chargebeeUrl = response.access_url;

          if ( this.openBillingType === 'home' ) {
            $('.chargebeeWrapper').removeClass('hidden');
          }

          $(`.iframe-${this.openBillingType}`).attr('src', this.chargebeeUrl);
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetStreams
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.streams = response.data;
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onSubscribe
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.guid !== 'undefined' ) {
          this.loading = false;

          this.closeContentStream();
          swal(
            'Subscribed!',
            `You can view your new articles by clicking 'My Articles' tab`,
            'success'
          );
          this.changeDetector.detectChanges();
        }
      }
    );

    this.particaService.onGetUserStreams
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( response !== undefined ) {
          this.subscribedList = response.map( (stream) => stream.contentStreamId );

          this.particaService.httpGetStreams();
        }
      }
    );

    this.initCreditCardForm();
    this.initForms();
  }

  initPartica() {
    if ( this.authUser.user.partica_registered === 1 ) {
      const token = atob(localStorage.getItem('PARTICA_TOKEN'));
      const user_id =  atob(localStorage.getItem('PARTICA_USER_ID'));
      const expiry = atob(localStorage.getItem('PARTICA_EXPIRY'));
      this.isRegistered = true;

      if ( token && user_id && expiry !== new Date().toISOString().split('T')[0] ) {
        this.onCheckAccount();
      } else {
        this.particaAccountId = user_id;
      }

    } else {
      this.isRegistered = false;
    }
  }

  initForms() {
    this.subscribeForm = new FormGroup({
      'selection': new FormControl('', Validators.required)
    });
  }

  initCreditCardForm() {
    this.creditCardForm = new FormGroup({
      number: new FormControl('', Validators.required),
      cvc: new FormControl('', Validators.required),
      exp_month: new FormControl('', Validators.required),
      exp_year: new FormControl('', Validators.required)
    });
  }

  getDefaultArticles() {
    this.loading = true;
    this.particaService.httpGetArticles({
      query: this.currentKeyword,
      facets: [
        'syndicationTags',
        'keywords',
        'price,values:5000|10000|15000|20000',
        'wordCount,values:300|600'
      ]
    });
  }

  onCheckAccount() {
    this.loading = true;
    this.particaService.httpCheckAccount();
  }

  formatFacetTitle(title) {
    switch (title) {
      case 'wordCount':
        return 'Word Count';

      case 'syndicationTags':
        return 'Categories';

      case 'price':
        return 'Price';

      case 'keywords':
        return 'Keywords';

      default:
        return 'Default';
    }
  }

  objectToArray(object) {
    return Object.entries(object);
  }

  readArticle(article) {
    this.tmpIssueGuid = article.issueGuid;

    this.particaService.httpGetArticle({
      issueId: article.issueId,
      articleId: article.articleId
    });
    this.loading = true;
  }

  closeArticle() {
    $('.read-article').addClass('hidden');
  }

  closeShoppingCart() {
    $('.shopping-cart').addClass('hidden');
  }

  closeContentStream() {
    $('.content-subscribe').addClass('hidden');
  }

  htmlToPlaintext(html) {
    return html ? String(html).replace(/<(?!\s*\/?\s*x\b)[^>]*>/gi, '') : '';
  }

  onAddArticleToCart(article) {
    this.particaService.httpPostCart({
      CustomerAccountId: this.particaAccountId,
      ArticleId: article.articleId
    });
    this.loading = true;

    $(`.${article.articleId}`).attr('data-tooltip', 'Added to Cart');
    $(`.${article.articleId}`).html(`<i class="icon feather icon-check-square"></i>`)

    this.changeDetector.detectChanges();
  }

  showShoppingCart() {
    this.particaService.httGetCart({
      CustomerAccountId: this.particaAccountId
    });
    this.loading = true;
  }

  calculatePrice(cartItems) {
    let totalPrice = 0;

    if ( typeof cartItems !== 'undefined' ) {
      cartItems.forEach(element => {
        totalPrice += this.formatDecimalPrice(element.article.price);
      });
    }

    return this.formatPrice(totalPrice);
  }

  formatPrice(price) {
    return price.toLocaleString();
  }

  removeCartItem(articleId) {
    this.particaService.httpDeleteCartItem({
      CustomerAccountId: this.particaAccountId,
      ArticleId: articleId
    });
    this.loading = true;
  }

  onSearchFilter(facet, filter, event) {
    this.articles = [];
    this.currentPage = 1;
    this.maxPage = 1;

    this.scrollEnable = false;

    this.storeSearch(facet.facetName, filter[0]);
    this.currentFilter.push(facet.facetName);

    const _filters = [];
    this.currentFilter.forEach(element => {
      const searchValue = this.getSearchValue(element);

      if ( searchValue !== null ) {
        _filters.push(JSON.parse(searchValue));
      }
    });
    const searchFilters = Object.assign({}, ..._filters.map(item => ({ [item.name]: item.value })));

    this.onSearch(searchFilters);
  }

  getSearchFilters() {
    const _filters = [];

    this.currentFilter.forEach(element => {
      const searchValue = this.getSearchValue(element);

      if ( searchValue !== null ) {
        _filters.push(JSON.parse(searchValue));
      }
    });

    return Object.assign({}, ..._filters.map(item => ({ [item.name]: item.value })));
  }

  storeSearch(facetName, value) {
    localStorage.setItem(facetName + '_value', '{"name": "' + facetName + '", "value": "' + value + '"}');
  }

  getSearchValue(facetName) {
    return localStorage.getItem(facetName + '_value');
  }

  checkIfUsingFilter(facetName) {
    return this.availableFilters.includes(facetName);
  }

  clearFilter(facetName) {
    this.currentPage = 1;
    this.maxPage = 1;
    this.scrollEnable = false;

    localStorage.removeItem(facetName + '_value');

    const _filters = [];
    this.currentFilter.forEach(element => {
      const searchValue = this.getSearchValue(element);

      if ( searchValue !== null ) {
        _filters.push(JSON.parse(searchValue));
      }
    });
    const searchFilters = Object.assign({}, ..._filters.map(item => ({ [item.name]: item.value })));

    this.onSearch(searchFilters);
  }

  onSearch(searchFilters, page = 1) {
    let currentKeyword = this.currentKeyword;
    if ( this.currentKeyword === '' ) {
      currentKeyword = '*';
    }
    this.loading = true;
    let search = <any>{
      query: currentKeyword,
      facets: [
        'syndicationTags',
        'keywords',
        'price,values:5000|10000|15000|20000',
        'wordCount,values:300|600'
      ],
      page: page
    };
    if ( searchFilters !== '' || Object.keys(this.getSearchFilters()).length > 0 ) {
      searchFilters = this.getSearchFilters();
      search = {
        query: currentKeyword,
        facets: [
          'syndicationTags',
          'keywords',
          'price,values:5000|10000|15000|20000',
          'wordCount,values:300|600'
        ],
        page: page,
        filters: searchFilters
      };
    }
    this.particaService.httpGetArticles(search);
  }

  checkActiveClass(facetName) {
    return $('.facet-' + facetName).hasClass('facet-active');
  }

  checkPaymentSource(type) {
    this.purchaseType = type;
    if ( $('#agreeTerms').is(':checked') || this.purchaseType === 'subscription' ) {
      this.particaService.httpCheckPaymentSource({
        CustomerAccountId: this.particaAccountId,
      });
      this.loading = true;
    } else {
      swal(
        'You need to agree with the license terms',
        '',
        'error'
      );
    }
  }

  onSubmitCard() {
    $('.new-payment-form').addClass('hidden');
  }

  onBackRefresh() {
    window.location.href = '/templates';
  }

  onEnterSearch(event) {
    if ( event.which === 13 ) {
      this.currentPage = 1;
      this.maxPage = 1;
      this.scrollEnable = false;
      this.onSearch('');
    }
  }

  getPurchasedArticles() {
    this.loading = true;
    this.particaService.httpGetPurchasedArticles({
      externalId: md5(this.authUser.user.email),
      partnerId: this.appConfig.PARTICA_PARTNERID
    });
  }

  onChangeTab(val) {
    this.currentTab = val;

    if ( this.currentTab === 'search' ) {
      this.getDefaultArticles();
    }

    if ( this.currentTab === 'purchase' ) {
      this.purchasedArticles = [];
      this.getPurchasedArticles();
    }

    if ( this.currentTab === 'subscription' ) {
      this.particaService.httpGetUserStreams({
        partnerId: this.appConfig.PARTICA_PARTNERID,
        externalId: md5(this.authUser.user.email)
      });
    }

    if ( this.currentTab !== 'subscriptionInfo' ) {
      this.loading = true;
    }

    this.changeDetector.detectChanges();
  }

  getPurchasedArticle(articleId, command = 'read') {
    this.loading = true;
    this.purchasedCommand = command;

    this.particaService.httpGetPurchasedArticle({
      externalId: md5(this.authUser.user.email),
      partnerId: this.appConfig.PARTICA_PARTNERID,
      articleId: articleId
    });
  }


  mainContentClick() {
    if ( this.outsideClick ) {
      this.outsideClick = false;
      $('.side-container').each( (i, element) => {
        if ( !$(element).hasClass('hidden') ) {
          $(element).addClass('hidden');
        }
      });
    }
  }

  onScroll(event) {
    if ( this.articles.length < this.totalArticles && this.scrollEnable
      && this.currentTab === 'search' ) {
      event.preventDefault();
      const elem = $(event.target);
      if (elem[0].scrollHeight - elem.scrollTop() === elem.outerHeight()) {
        this.onSearch('', this.currentPage);
        this.loading = true;
      }
    }
  }

  closeBuilderModal() {
    this.particaService.onBuilderModalClose.next(true);
  }

  insertArticle(article, image) {
    $('#selectPictureModal').modal('hide');

    article.image_src = image;
    this.particaService.onBuilderInsertArticle.next(article);
  }

  openBilling(type) {
    this.openBillingType = type;
    this.loading = true;
    this.particaService.httpGetSsoToken({
      customerAccountId: this.particaAccountId
    });
    this.changeDetector.detectChanges();
  }

  onBillingClose() {
    $('.chargebeeWrapper').addClass('hidden');
    $('.chargebeeWrapper iframe').removeAttr('src');
  }

  startTour() {
    const intro = introJs();

    intro.setOption('disableInteraction', true);
    intro.setOption('exitOnOverlayClick', false);
    intro.setOption('hidePrev', true);
    intro.setOption('hideNext', true);
    intro.setOption('showStepNumbers', false);
    intro.setOption('overlayOpacity', '0.5');

    if ( this.page === 'builder' ) {
      intro.setOption('tooltipClass', 'partica-tour-tools');
      intro.setOption('highlightClass', 'partica-builder');
    }

    intro.addSteps([
      {
        element: document.querySelector('.intro-1'),
        intro: 'Here you will find all articles that are available for purchase, scroll down to load more'
      },
      {
        element: document.querySelector('.intro-2'),
        intro: 'Articles can be filtered by how many words an article contains, common categories, price and common keywords'
      },
      {
        element: document.querySelector('.intro-3'),
        intro: 'You can search articles by keywords using the search filter'
      },
      {
        element: document.querySelector('.intro-4'),
        intro: 'Each article you can see the Article title as well as the article image'
      },
      {
        element: document.querySelector('.intro-5'),
        intro: 'The Article author is shown here'
      },
      {
        element: document.querySelector('.intro-6'),
        intro: 'How many words the article contains'
      },
      {
        element: document.querySelector('.intro-7'),
        intro: 'Licence type'
      },
      {
        element: document.querySelector('.intro-8'),
        intro: 'Price of article'
      },
      {
        element: document.querySelector('.intro-9'),
        intro: 'Read the full article in a slide in window'
      },
      {
        element: document.querySelector('.intro-10'),
        intro: 'Add article to your shopping cart'
      },
      {
        element: document.querySelector('.intro-11'),
        intro: 'Tab to view all you puchased articles'
      }
      // {
      //   element: document.querySelector('.intro-12'),
      //   intro: 'Here will display articles from subcriptions'
      // }
    ]);

    intro.start();
  }

  particaHelp() {
    window.open('/help/faqs', '_blank');
  }

  selectStream(index) {
    this.selectedStream = this.streams[index];
    $('.content-subscribe').hide();
    $('.content-subscribe').removeClass('hidden').toggle('slide', {
      direction: 'right'
    });

    setTimeout(() => {
      this.outsideClick = true;
    }, 1000);
  }

  onSubscribe() {
    const subscribeFormValues = this.subscribeForm.value;

    if ( subscribeFormValues['selection'] === '' ) {
      swal(
        'Invalid Selection',
        'Select a correct subscription level',
        'error'
      );
      return false;
    }

    const data = {
      externalId: md5(this.authUser.user.email),
      streamId: subscribeFormValues['selection'],
      EmailAddress: this.authUser.user.email
    };

    this.particaService.httpSubscribeStream(data);
  }

  triggerClick(tab) {
    $(`#${tab}`).trigger('click');

    if ( tab === 'articleLibrary' ) {
      this.getDefaultArticles();
    }

    if ( tab === 'purchasedLibrary' ) {
      this.getPurchasedArticles();
    }

    if ( tab === 'subscriptionLibrary' ) {
      this.particaService.httpGetUserStreams({
        partnerId: this.appConfig.PARTICA_PARTNERID,
        externalId: md5(this.authUser.user.email)
      });
    }

    this.loading = true;
    this.changeDetector.detectChanges();
  }

  isSubscribed(contentId: number) {
    return this.subscribedList.includes(contentId);
  }

  formatDecimalPrice(price: number) {
    return price / Math.pow(10, 2);
  }

  cleanTitle(content: String) {
    return content.replace(/<[^>]*>/g, '');
  }

  resizeImage(url: String, size = 600) {
    if ( url === null ) {
      return false;
    }

    const imageExtension = url.split('.').reverse()[0];
    const imageUrlWithoutExtension = url.split(`.${imageExtension}`);

    url = `${imageUrlWithoutExtension[0]}.${size}.${imageExtension}`;

    return url;
  }

  formatSearchPrice(value, parent) {
    if ( parent === 'price' ) {
      try {
        if ( value.includes(' < ') ) {
          const price = value.split(' < ');
          return ` < ${this.formatDecimalPrice(price[1])}`;
        }
        if ( value.includes(' - ') ) {
          const price = value.split(' - ');
          return `${this.formatDecimalPrice(price[0])} - ${this.formatDecimalPrice(price[1])}`;
        }
        if ( value.includes('+') ) {
          const price = value.split('+');
          return `${this.formatDecimalPrice(price[0])}+`;
        }
      } catch (err) {
        return value;
      }
    }

    return value;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/partica/partica.component.ts